import { defineStore } from 'pinia';

import { LanguageEnum } from '@interface/public';
import { MenuInterface, BreadcrumbInterface } from '@interface/page';

export interface OverseasStateInterface { // 平台状态
  menu: {
    isOpen: boolean; // 是否展开
    openKey: string[]; // 展开的Key
    selectKey: string[]; // 选择的Key
    list: MenuInterface[]; // 列表
  };
  breadcrumb: BreadcrumbInterface[];
  modal: any; // 对话框
}

/**
 * 海外数据
 */
export default defineStore('overseas', {
  state: (): OverseasStateInterface => { // 状态
    return {
      menu: {
        isOpen: false,
        openKey: [],
        selectKey: [],
        list: [
          {
            name: 'Home',
            href: $Enum.RouterEnum.Home
          }
        ]
      },
      breadcrumb: [],
      modal: {}
    };
  },
  getters: { // 获取
  },
  actions: { // 方法
    /**
     * 更新菜单
     * @param {*} data 数据
     */
    updateMenu(data: any): void {
      $FN.Object.synchronize(this.menu, data);
    },
    
    /**
     * 更新面包屑
     * @param {BreadcrumbInterface[]} data 数据
     */
    updateBreadcrumb(data: BreadcrumbInterface[]): void {
      $FN.Object.synchronize(this.breadcrumb, data);
    },
    
    //----- 对话框 Start -----//
    /**
     * 更新对话框
     * @param {*} data 数据
     */
    updateModal(data: any): void {
      this.modal = data;
    },
    
    /**
     * 开启对话框
     * @param {string} name 名称
     * @param {any} data 数据
     */
    openModal(name: string, data: any = null): void {
      this.modal[name]?.[0]?.open(data);
    },
    
    /**
     * 关闭对话框
     * @param {string} name 名称
     */
    closeModal(name: string): void {
      this.modal[name]?.[0]?.close();
    },
    //----- 对话框 End -----//
    
    //----- 语言 Start -----//
    /**
     * 获取语言
     * @return {LanguageEnum} language 语言
     */
    getLanguage(): LanguageEnum {
      let language = $Enum.LanguageEnum.ZH;
      
      switch ($FN.LocalStorage.get($Enum.StorageEnum.Language) || navigator.language) {
        case $Enum.LanguageEnum.ZH:
        case $Enum.LanguageEnum.ZH_CN:
        case $Enum.LanguageEnum.ZH_HK:
        case $Enum.LanguageEnum.ZH_TW:
          language = $Enum.LanguageEnum.ZH;
          break;
        case $Enum.LanguageEnum.EN:
        default:
          language = $Enum.LanguageEnum.EN;
          break;
      }
      
      return language;
    },
    
    /**
     * 设置语言
     * @param {LanguageEnum} language 语言
     */
    setLanguage(language: LanguageEnum): void {
      $FN.LocalStorage.set({
        [$Enum.StorageEnum.Language]: language
      });
      
      $Application.Router.push($Enum.RouterEnum.Root);
    }
    //----- 语言 End -----//
  }
});